import accordion from './js/accordion.js'
import countdown from './js/countdown.js'

import 'chocolat/dist/css/chocolat.css'
import './js/touch-stuff/touch-svg.js'
import './js/touch-stuff/touch-image.js'

accordion.init('visitors')
countdown.init()

function loadBrandImages() {
  const brandImages = document.querySelectorAll('#brands img')

  brandImages.forEach((img) => {
    img.onload = () => {
      img.parentElement.querySelectorAll('.progress').forEach((spinner) => {
        spinner.remove()
      })
    }
    img.src = img.dataset.src
  })
}

function openLightbox(img) {
  const lightbox = document.getElementById('image-lightbox')
  const lightboxScreen = lightbox.querySelector('.screen')
  const closeButton = lightbox.querySelector('.close-btn')

  if (lightbox.classList.contains('open')) {
    return
  }
  closeButton.addEventListener('click', () => {
    lightbox.classList.remove('open')
    lightboxScreen.innerHTML = ''
  })

  lightbox.classList.add('open')
  document.body.style.overflow = 'hidden'

  let imageElement;
  if (img.src.substr(-4) === '.svg') {
    imageElement = document.createElement('touch-svg')
  } else {
    imageElement = document.createElement('touch-image')
  }
  imageElement.setAttribute('image', img.src)
  lightboxScreen.appendChild(imageElement)
}

function loadImages() {
  const images = document.querySelectorAll('img.preload')

  images.forEach((img) => {
    img.onload = () => {
      img.parentElement.querySelectorAll('.progress').forEach((spinner) => {
        spinner.remove()
      })

      img.addEventListener('click', () => {
        openLightbox(img)
      })

      if (img.closest('.accordion__body') && img.closest('.accordion__item.open')) {
        img.closest('.accordion__body').style.height = 'auto'
      }
    }
    img.src = img.dataset.src
  })
}

loadBrandImages()
//loadIndoorMapImage()
//loadOutdoorMapImage()
loadImages()
